/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![QuestsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACMElEQVR4nN2VuYsUQRTGR00MvK/EE83FAzRSEQQHp9/Ri9Xvba8yf8GyrJGCMInRLhqoKxt5ILp4JSbmYiCYqqiRsJnXekQrrCvV7Thd1TVMd6gFRdPd33u/V19Vv240/tvR6XSWAukosL4B0nkkfdZ9B6xPgeQnkL5FljGrrQ1A0ivIutib8u0vgPSr84702sCERLIDWabsFUB3I+uvYhIgnSkAZly4LhKle7JYlmlm2RWoWG7nieQTslz2KvxwYijd3tVGkdlmn7kFyFUg/Zzr5W7IEicgC2L9jqSPiGSrr4/jkS3I8tBa58chy8cygOWLm1zmomh4wyBrjTHrQrEhi+55nl8clLw7gHTCs/S+I7AWAEvknA5MjlYFEMkhx1ZUbA2lO3sVsMz5PjaN2Vgd0F5T3r+CTUAy6wuOtNvLqwKMMctKAJLZ4gou+YJWy2yuCojjU5vKJ0knixWsBpYXjgD1ZFUAsJBnz3NjzApHFMXJPiB93TsJ8qQG4HFhk18h6l5HgKjjQLJQWiZqXCF55LeV/F7O9AAsYwEP7bfwgyg53i85YnIs/CVnsaNua2aZDgtlAVhvISaHm82RVYi40p57YL0eXHXeKqaCLdx6Z5dmLWNO9wPruexfEEySVTmPLGezONRxO21XrbRxrVa6NgfY7toXYLvneebT6xs1xxIkeV84Ue+Q9QaQXrATSW7+eda15GVdgP0t3rGtmnn4QD8Noh4ElgcWWhvwz4zfA2jD9nwXu10AAAAASUVORK5CYII=)
 */
export const QuestsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7.5 21.7a8.95 8.95 0 0 1 9 0 1 1 0 0 0 1-1.73c-.6-.35-1.24-.64-1.9-.87.54-.3 1.05-.65 1.52-1.07a3.98 3.98 0 0 0 5.49-1.8.77.77 0 0 0-.24-.95 3.98 3.98 0 0 0-2.02-.76A4 4 0 0 0 23 10.47a.76.76 0 0 0-.71-.71 4.06 4.06 0 0 0-1.6.22 3.99 3.99 0 0 0 .54-5.35.77.77 0 0 0-.95-.24c-.75.36-1.37.95-1.77 1.67V6a4 4 0 0 0-4.9-3.9.77.77 0 0 0-.6.72 4 4 0 0 0 3.7 4.17c.89 1.3 1.3 2.95 1.3 4.51 0 3.66-2.75 6.5-6 6.5s-6-2.84-6-6.5c0-1.56.41-3.21 1.3-4.51A4 4 0 0 0 11 2.82a.77.77 0 0 0-.6-.72 4.01 4.01 0 0 0-4.9 3.96A4.02 4.02 0 0 0 3.73 4.4a.77.77 0 0 0-.95.24 3.98 3.98 0 0 0 .55 5.35 4 4 0 0 0-1.6-.22.76.76 0 0 0-.72.71l-.01.28a4 4 0 0 0 2.65 3.77c-.75.06-1.45.33-2.02.76-.3.22-.4.62-.24.95a4 4 0 0 0 5.49 1.8c.47.42.98.78 1.53 1.07-.67.23-1.3.52-1.91.87a1 1 0 1 0 1 1.73Z"
        className={colorClass}
      />
    </svg>
  );
};
